export class ReportLogDto{
    reportName = '';
    reportId = 'Test';
    userName: string | null = '';
    userEmail: string | null = 'Test';
    workspaceId = 'Test';
}